export const OPTIONS_SCHEMA_VERSION = 1;

export const OPTIONS_SUBMODES = ["same-day", "longer-term"];
export const OPTION_TYPES = ["call", "put"];
export const OPTION_DIRECTIONS = ["bullish", "bearish"];
export const OPTION_POSITION_STRUCTURES = ["long-single-leg"];
export const OPTION_PURCHASE_TYPES = ["debit"];
export const OPTION_ALERT_TYPES = ["options-opportunity"];
export const OPTION_STRATEGIES = [
  "Strong same-day call momentum",
  "Strong same-day put momentum",
  "Developing call continuation",
  "Developing put reversal",
  "Wide-spread momentum contract",
  "Low-volume call watch",
  "Low-open-interest put watch",
  "Critical implied-volatility risk",
  "Missing critical liquidity evidence",
  "Near-expiration gamma-risk watch",
  "Longer-term bullish opportunity",
  "Longer-term bearish put opportunity",
];
export const OPTION_STATES = [
  "Monitoring",
  "Building",
  "Ready to review",
  "Weakening",
  "Risk blocked",
  "Insufficient evidence",
];
export const OPTION_RISK_LEVELS = ["Low", "Moderate", "High", "Critical"];
export const OPTION_EVIDENCE_STATUSES = [
  "simulated",
  "system-derived",
  "static-demo",
  "hypothesis",
  "unavailable",
];
export const OPTION_FACTOR_STATUSES = [
  "positive",
  "negative",
  "conflicting",
  "unavailable",
];

export const OPTION_FACTOR_DEFINITIONS = Object.freeze({
  underlyingAlignment: { label: "Underlying SmartFlow alignment", weight: 12, critical: true },
  momentum: { label: "Underlying direction and momentum", weight: 9, critical: true },
  liquidity: { label: "Contract liquidity", weight: 10, critical: true },
  spreadQuality: { label: "Bid/ask spread quality", weight: 9, critical: true },
  volumeActivity: { label: "Options volume", weight: 7, critical: true },
  openInterestQuality: { label: "Open interest", weight: 7, critical: true },
  activityRatio: { label: "Volume/open-interest activity", weight: 5, critical: false },
  ivRisk: { label: "Implied-volatility risk", weight: 7, critical: true },
  deltaSuitability: { label: "Delta suitability", weight: 6, critical: false },
  timeSuitability: { label: "Time to expiration", weight: 6, critical: true },
  breakevenQuality: { label: "Breakeven distance", weight: 6, critical: false },
  catalystTiming: { label: "Catalyst timing", weight: 5, critical: false },
  evidenceCompleteness: { label: "Evidence completeness", weight: 4, critical: false },
  freshness: { label: "Evidence freshness", weight: 3, critical: true },
  contradictions: { label: "Contradictions", weight: 2, critical: false },
  maxLossClarity: { label: "Maximum-loss clarity", weight: 2, critical: true },
});

export const OPTION_FACTOR_KEYS = Object.freeze(
  Object.keys(OPTION_FACTOR_DEFINITIONS)
);

export const OPTION_SNAPSHOT_KEYS = Object.freeze([
  "schemaVersion",
  "id",
  "contractId",
  "symbol",
  "contractType",
  "positionStructure",
  "purchaseType",
  "alertType",
  "direction",
  "submode",
  "setup",
  "expiration",
  "dte",
  "asOf",
  "updatedAt",
  "source",
  "evidenceStatus",
  "demoLabel",
  "underlyingPrice",
  "strike",
  "bid",
  "ask",
  "spread",
  "contractMultiplier",
  "premium",
  "maxLoss",
  "volume",
  "openInterest",
  "volumeOpenInterestRatio",
  "impliedVolatility",
  "delta",
  "breakeven",
  "distanceToBreakevenPercent",
  "catalyst",
  "catalystTiming",
  "riskLevel",
  "underlyingRisk",
  "state",
  "stability",
  "signals",
]);

export const OPTION_THRESHOLDS = Object.freeze({
  "same-day": Object.freeze({
    dteMin: 0,
    dteMax: 0,
    maximumSpreadPercent: 12,
    minimumVolume: 200,
    minimumOpenInterest: 300,
    maximumAgeSeconds: 120,
    criticalIvPercent: 150,
    readySuitability: 70,
    readyConfidence: 70,
  }),
  "longer-term": Object.freeze({
    dteMin: 14,
    dteMax: 365,
    maximumSpreadPercent: 18,
    minimumVolume: 50,
    minimumOpenInterest: 200,
    maximumAgeSeconds: 900,
    criticalIvPercent: 120,
    readySuitability: 68,
    readyConfidence: 68,
  }),
});

export const SIMULATED_OPTIONS_NOTICE =
  "Simulated options demonstration data — not current market data.";
